var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlerta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9908 2.0453C6.49522 2.0453 2.04071 6.49981 2.04071 11.9954C2.04071 17.491 6.49522 21.9455 11.9908 21.9455C17.4864 21.9455 21.9409 17.491 21.9409 11.9954C21.9409 6.49981 17.4864 2.0453 11.9908 2.0453ZM12.0138 17.5232C11.1893 17.5232 10.5167 16.8507 10.5167 16.0261C10.5167 15.2015 11.1893 14.529 12.0138 14.529C12.8384 14.529 13.511 15.2015 13.511 16.0261C13.511 16.8507 12.8384 17.5232 12.0138 17.5232ZM13.8703 6.80384L13.2852 12.6035C13.2622 12.8292 13.0411 13.0042 12.7785 13.0042H11.2676C11.005 13.0042 10.7885 12.8338 10.7609 12.6081L10.1021 6.80845C10.0745 6.55048 10.3094 6.32476 10.6088 6.32476H13.3636C13.663 6.32937 13.8979 6.55048 13.8703 6.80384Z",
    fill: "#FA4443"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerta);
export default __webpack_public_path__ + "static/media/Alerta.a253292f.svg";
export { ForwardRef as ReactComponent };